import type { PrivateEventDetail } from '../../api/privateEvents';
import { EditSection } from '../shared/EditSection';

import AddOnsNotesForm from './AddOnsNotesForm';
import AddOnsNotesView from './AddOnsNotesView';
import { useAddOnsNotesForm } from './use-add-ons-notes-form';

export default function AddOnsNotesSection({
  event,
  readOnly,
  denied,
  onDenied,
}: {
  event: PrivateEventDetail;
  readOnly: boolean;
  denied: boolean;
  onDenied: () => void;
}) {
  const form = useAddOnsNotesForm(event, onDenied);
  return (
    <EditSection
      title="Add-ons & notes"
      editLabel="Edit Add-ons & notes"
      readOnly={readOnly}
      frozen={denied}
      onEdit={form.begin}
      onCancel={form.begin}
      onSave={form.submit}
      view={<AddOnsNotesView event={event} />}
      form={<AddOnsNotesForm form={form} />}
    />
  );
}
